import { Box, Image as ImageIcon, Layers3, Tag } from "lucide-react";

const catalogApi = `${process.env.REACT_APP_BACKEND_URL}/api/catalog`;

const typeLabel = (type) =>
  (type || "record")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const formatDate = (value) => {
  if (!value) {
    return "No release date";
  }
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(`${value}T12:00:00`));
};

export default function CatalogRecordPreview({ form, parentOptions, status }) {
  const imageId =
    form.images?.primary_image_id ||
    form.images?.logo_image_id ||
    form.images?.symbol_image_id ||
    form.images?.icon_image_id;
  const parentRecord = Object.values(form.parents || {})
    .filter(Boolean)
    .map((parentId) =>
      Object.values(parentOptions || {})
        .flat()
        .find((option) => option.record_id === parentId),
    )
    .find(Boolean);
  const displayName = form.display_name || form.name || "Untitled record";
  const code = form.official_set_code || form.abbreviation || form.short_name;

  return (
    <aside
      className="catalog-preview-panel"
      data-testid="catalog-live-preview-panel"
    >
      <div className="catalog-preview-heading">
        <span>Live preview</span>
        <small>How it will appear in Cardfolio</small>
      </div>
      <article
        className="catalog-preview-card"
        data-testid="catalog-live-preview-card"
      >
        <div
          className="catalog-preview-art"
          data-testid="catalog-live-preview-image"
        >
          {imageId ? (
            <img src={`${catalogApi}/assets/${imageId}`} alt="" />
          ) : (
            <ImageIcon size={26} />
          )}
          {form.images?.symbol_image_id && (
            <img
              className="catalog-preview-symbol"
              src={`${catalogApi}/assets/${form.images.symbol_image_id}`}
              alt=""
            />
          )}
        </div>
        <div className="catalog-preview-copy">
          <div className="catalog-preview-topline">
            <span>{typeLabel(form.record_type)}</span>
            <b className={`catalog-status-badge is-${status}`}>{status}</b>
          </div>
          {code && <p className="catalog-preview-code">{code}</p>}
          <h3>{displayName}</h3>
          <p>
            {parentRecord?.display_name ||
              parentRecord?.name ||
              "Independent record"}
          </p>
          <dl>
            <div>
              <dt>Language</dt>
              <dd>{form.language || "Not specified"}</dd>
            </div>
            <div>
              <dt>Released</dt>
              <dd>{formatDate(form.release_date)}</dd>
            </div>
            {form.total_card_count && (
              <div>
                <dt>Cards</dt>
                <dd>{form.total_card_count}</dd>
              </div>
            )}
          </dl>
        </div>
      </article>
      <div className="catalog-preview-context">
        <span>
          <Tag size={14} />{" "}
          {form.active ? "Active catalog record" : "Inactive record"}
        </span>
        <span>
          {form.parents?.set_id ? <Layers3 size={14} /> : <Box size={14} />}
          {parentRecord ? "Relationship linked" : "No parent link"}
        </span>
      </div>
    </aside>
  );
}
